import DocumentsPage from './pages/Documents'
import DocumentDetailPage from './pages/DocumentDetail'
import DocumentMain from './pages/DocumentMain'
import SearchDocumentPage from './Search/pages'
import DocumentsManagement from './pages/DocumentsManagement'
import WorkflowRequestHistory from './Workflow/pages/WorkflowRequestHistory'
import store from "@/vuex/store";
const router = {
  path: 'documents',
  name: 'documents',
  component: DocumentMain,
  children: [
    {
      path: '/',
      name: 'documents',
      component: DocumentsPage,
      meta: {
        requiresAuth: true,
        requiresPermission: true,
        action: 27,
        titleHeader: 'Documentos'
      },
      beforeEnter: (to, from, next) => {
        const isInIframe = window.self !== window.top;
        
        if (isInIframe) {
          const actions = store.getters.getActions || [];
          const actionsIds = actions.map(action => action.id);
          const isApprover = actionsIds.includes('71');
          
          if (isApprover) {
            return next({ name: 'licensesManager' });
          } else {
            return next({ name: 'licenses' });
          }
        }
        
        next();
      }
    },
    {
      name: 'documents-detail',
      path: 'detail',
      component: DocumentDetailPage,
      meta: {
        requiresAuth: true,
        requiresPermission: true,
        action: 27,
        titleHeader: 'Documentos'
      },
      beforeEnter: (to, from, next) => {
        if (window.innerWidth > 1023) {
          next('/documents')
        }
        next()
      }
    },
    {
      path: 'search',
      name: 'documents-search',
      component: SearchDocumentPage,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: 'request',
      name: 'documentsManagement',
      component: DocumentsManagement,
      meta: {
        requiresAuth: true
      },
      beforeEnter: (to, from, next) => {
        if (store.getters.getActions.length > 0) {
          const actionIds = []
          let entryAction = false
          for (let key in store.getters.getActions) {
            actionIds.push(store.getters.getActions[key].id)
            if (
              String(store.getters.getActions[key].id).includes('77') ||
              String(store.getters.getActions[key].id).includes('205')
            ) {
              entryAction = true
            }
          }
          if (!entryAction) {
            next('/403')
          } else if (
            actionIds.indexOf('77') > -1 ||
            actionIds.indexOf('205') > -1
          ) {
            next()
          } else {
            next('/404')
          }
        }
      }
    },
    {
      name: 'documentRequestHistory',
      path: 'request/history',
      component: WorkflowRequestHistory,
      meta: {
        requiresAuth: true,
        action: 301,
        requiresPermission: true
      }
    }
  ]
}

export default router
